import { commonConstants } from "../constants/pro";

export const commonActions = {
  getMetaData,
  getMetaDataSuccess,
};

function getMetaData() {
  return {
    type: commonConstants.METADATA_REQUEST,
    payload: { type: "all" }
  };
}

function getMetaDataSuccess(payload) {
  return {
    type: commonConstants.METADATA_SUCCESS,
    payload
  };
}